
import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

const LearnerCourseLoading = () => {
  return (
    <div className="flex flex-col items-center py-24">
      <Skeleton className="w-96 h-8 mb-6" />
      <Skeleton className="w-full max-w-2xl aspect-video mb-4" />
      <Skeleton className="w-full max-w-2xl h-24" />
    </div>
  );
};

export default LearnerCourseLoading;
